import { createStore } from 'redux'
import rootReducer from './reducer'
import enhancers from './enhancers'

/**
 * Configures the redux store of the application
 *
 * Dependencies can be passed into this function to override the defaults that
 * would be injected into the middleware (see enhancers/index.js). This is used
 * during testing time to override things like our http client and localStorage
 *
 * On initializing the store we dispatch an action to setup user information
 * that is potentially held in storage
 *
 * @example
 * // showing passing in deps for testing situations
 * const { TestHttpClient } from '@testing-utils/testHttpClient'
 * const testStorage from '@testing-utils/testStorage'
 *
 * configureStore({ deps: { http: new TestHttpClient(), storage: testStorage() } })
 *
 * @example
 * // not passing deps, using the defaults which actually make network requests
 * // and works with real local storage
 *
 * configureStore()
 *
 * @param {object} [deps] - dependencies to pass to middleware
 * @param {object} [deps.http] - an http instance to override the http client
 * @param {object} [deps.storage] - a storage instance to override storage client
 * @param {object} [deps.keycloak] - keycloak-js instance
 * @returns {store} a redux store
 */
export default ({ deps } = {}) => {
  const store = createStore(rootReducer, enhancers(deps))

  return store
}
